import { render, staticRenderFns } from "./EditScriptDialog.vue?vue&type=template&id=c0db7050"
import script from "./EditScriptDialog.vue?vue&type=script&lang=js"
export * from "./EditScriptDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports